<template>
    <div class="apprentice-simple-card">
        <b-form-group
            class="vso-style-boolean"
            :label="$t('profile.vso_style')"
            label-for="vso-style-input">
            <b-form-checkbox
                id="vso-style-input"
                v-model="vsoStyle"
                :value="true"
                :unchecked-value="false"
                switch>
            </b-form-checkbox>
        </b-form-group>
        <b-form-group
            class="rubric-skill-sets-group"
            :label="$t('rubrics.choose_a_set_of_skills')">
            <design-2021-apprentice-multiselect-component
                v-model="selectedSkillTree"
                :multiple-select="false"
                label="name"
                :options="skillTreesIn"
                :placeholder="$t('rubrics.choose_a_set_of_skills')"
                :show-labels="false">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-button
            variant="primary"
            @click="save()">
            {{ $t('common.save') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-management-profile-settings-component',
    props: {
        profileSettingsIn: {
            type: Object,
            default: null,
        },
        skillTreesIn: {
            type: Array,
        },
    },
    data() {
        return {
            profileSettings: this.profileSettingsIn,
            vsoStyle: !!this.profileSettingsIn?.vso_style,
            selectedSkillTree: null,
        };
    },
    mounted() {
        if (this.profileSettingsIn) {
            this.selectedSkillTree = this.skillTreesIn.find(
                (skillTree) => skillTree.id === this.profileSettingsIn.skill_tree_id,
            );
        }
    },

    methods: {
        save() {
            let data = {
                vso_style: this.vsoStyle,
                skill_tree_id: this.selectedSkillTree.id,
            };

            this.alert.saving();
            this.axios.post(this.routes.managementProfileSettings(), data).then(
                (response) => {
                    this.profileSettings = response.data;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss"></style>
